import React, { forwardRef, type JSX } from 'react';
import { RouterLink } from '../RouterLink/RouterLink';

export const InternalLink = forwardRef<HTMLAnchorElement>(
  ({ href = '', ...rest }: JSX.IntrinsicElements['a'], ref) => (
    <RouterLink to={href} ref={ref} {...rest} />
  ),
);
